import { CSSProperties, MouseEventHandler } from 'react';

interface IIcon {
  /** The class the CMS stored: `at-*`, `ph-*` or `icon_*`. Unknown ones pass through. */
  name?: string | null;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLElement>;
}

/**
 * An icon whose class comes from the CMS.
 *
 * '@phosphor-icons/web' keys its glyph rules on `.ph.ph-users` but the CMS stores
 * only `ph-users`, so the family class is added here. Atlas and icomoon key theirs
 * on the icon class alone and pass through.
 *
 * Stays an `<i>`: several makeStyles blocks reach these icons via `& i::before`.
 */
export const Icon = ({ name, className, style, onClick }: IIcon) => {
  if (!name) return null;

  const cmsClass = String(name).trim();
  const withFamily = cmsClass.startsWith('ph-') ? `ph ${cmsClass}` : cmsClass;

  return (
    <i
      className={className ? `${withFamily} ${className}` : withFamily}
      style={style}
      onClick={onClick}
    />
  );
};
